import type { Assistant, AssistantFeature } from './types';

export const CREW_SALARY_ASSISTANT_ID = 'crew';
export const CREW_SALARY_FEATURE_ID = 'crewSalary';

export const crewSalaryAssistant: Assistant = {
  id: CREW_SALARY_ASSISTANT_ID,
  name: '人力资源总监',
  description: '已分配航线的飞机 ≥20 架，或经营至第 52 周后解锁。招募后可调整机组人员薪资水平，直接影响每航段的人均服务成本。',
  featureIds: [CREW_SALARY_FEATURE_ID],
  unlocked: (state) => state.aircraft.filter((a) => a.routeIds.length).length >= 20 || state.week >= 52,
  unlockRequirement: '已分配航线的飞机 ≥20 架，或经营至第 52 周',
  recruitCost: 150_000,
  weeklySalary: 6_000,
};

export const crewSalaryFeature: AssistantFeature = {
  id: CREW_SALARY_FEATURE_ID,
  name: '机组薪资调整',
  description: '允许将单架飞机的机组薪资倍率在 0.20~1.50 之间调整，影响 perPassengerCost。',
  assistantId: CREW_SALARY_ASSISTANT_ID,
};
